import { Stack, Typography } from '@mui/material'
import { Fragment } from 'react'
import { SkeletonText } from 'utoniq-ui'

import { ConsolePreSaleBox, PreSaleCardSkeleton } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { Action, State } from '@/components/pages/ConsoleEventDetail/template'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type PreSalesCellProps = {
  preSales: State['preSale']
  loading: boolean
  hasNextPage: boolean
  onFetchMore: Action['onFetchPreSalesMore']
  onTogglePreSalePublish: Action['onTogglePreSalePublish']
}

export const PreSalesCell: Cell<PreSalesCellProps> = ({
  preSales,
  loading,
  hasNextPage,
  onFetchMore,
  onTogglePreSalePublish,
}) => {
  const { t } = useTranslation('eventDetail')

  return (
    <CellFrame sx={{ pt: 3, px: 5, pb: 5 }}>
      {loading && !preSales?.edges?.length ? (
        <SkeletonText variant="h5" sx={{ pb: 5 }} />
      ) : (
        <Typography variant="h5" sx={{ pb: 5 }}>
          {t('', '関連付けた先行販売')}
        </Typography>
      )}
      <ScrollFetcher
        nodes={preSales?.edges.map(({ node }, index) => {
          if (!node) return <Fragment key={index} />

          return (
            <ConsolePreSaleBox
              preSale={node}
              key={node.id}
              onTogglePreSalePublish={onTogglePreSalePublish}
            />
          )
        })}
        componentProps={{ spacing: 5 }}
        loading={loading}
        hasNextPage={hasNextPage}
        onFetchMore={onFetchMore}
        emptyMessage={t('preSalesEmpty')}
        loadingComponent={
          <Stack spacing={3} sx={{ pt: 2 }}>
            {Array.from(Array(3).keys()).map(key => (
              <PreSaleCardSkeleton key={key} />
            ))}
          </Stack>
        }
      />
    </CellFrame>
  )
}
